import React, { useState } from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CustomLink from './CustomLink';

const CompanyDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        role='button'
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleMouseEnter}
      >
        <Typography
          style={{
            color: 'white',
            textTransform: 'none',
            marginRight: '4px',
            fontSize: '0.875rem',
          }}
        >
          Company
        </Typography>
        <ArrowDropDownIcon style={{ color: 'white' }} />
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMouseLeave}
        MenuListProps={{
          onMouseEnter: () => setAnchorEl(anchorEl),
          onMouseLeave: handleMouseLeave,
        }}
      >
        <MenuItem component={CustomLink} to='/content/about' onClick={handleMouseLeave}>
          <Typography variant='body2'>About</Typography>
        </MenuItem>
        <MenuItem component={CustomLink} to='/content/contact' onClick={handleMouseLeave}>
          <Typography variant='body2'>Contact</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default CompanyDropdown;
